import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {Tabs, TabLink, TabContent} from '../../../components/tabs'
import { MainButton } from 'components/button'
import { localize } from 'helpers/translator'
import styles from './share_embed.scss'

class shareEmbed extends Component {

	copyToClipboard = () => {
		this.input_element.focus()
		this.input_element.select()
		document.execCommand('copy')
	}

	clickHandler = () => {
		this.copyToClipboard()
		this.props.onSelect()
	}

	render() {
		const numrows = 3
		const tabLinks = []
		const tabs = []

		for (let i = 0; i < numrows; i++) {
			tabLinks.push(
				<div key={i} className={styles.embed_area_tabs_options_item}>
					<TabLink key={i} to={this.props.payload.sizes[i].text}>
						<i className={styles.embed_area_tabs_options_item_checkbox}></i>
						<label>{this.props.payload.sizes[i].text}</label>
					</TabLink>
				</div>
			)
		}

		for (let i = 0; i < numrows; i++) {
			tabs.push(
				<TabContent key={i} for={this.props.payload.sizes[i].text}>
					<textarea
						className={styles.embed_area_text}
						ref={
							input => {
								if (this.props.visibleTab === true && input !== null) {
									input.focus()
									input.select()
								}
								this.input_element = input
							}
						}
						defaultValue={this.props.payload.sizes[i].value} />
				</TabContent>
			)
		}

		return (

			<div className={styles.embed_area}>


				<div className={styles.embed_area_tabs}>

					<Tabs name='embed_share'
						handleSelect={
							(selectedTab, namespace) => {
								this.props.onTabChange(selectedTab, namespace)
							}
						}
						selectedTab={this.props.selectedEmbedRadio}
						activeClassStyle={styles.embed_area_tabs_active}
						activeLinkStyle={{}}>

						<div className={styles.embed_area_tabs_options}>
							<div className={styles.embed_area_tabs_options_label}>
								<label>
									{localize('share_embed_label')}
								</label>
							</div>
							{tabLinks}
						</div>
						<div className={styles.embed_area_tabs_current}>
							{tabs}
						</div>

					</Tabs>

				</div>

				<div className={styles.embed_area_btn_container}>
					<div className={styles.embed_area_btn_container_btn_copy}>
						<MainButton onClick={this.clickHandler}>{localize('btn_copy_text')}</MainButton>
					</div>
				</div>

			</div>
		)
	}

}

shareEmbed.defaultProps = {
	onSelect: () => {},
}

shareEmbed.propTypes = {
	payload: PropTypes.object,
	visibleTab: PropTypes.bool,
	onTabChange: PropTypes.func,
	selectedEmbedRadio: PropTypes.string,
	onSelect: PropTypes.func,
}

export default shareEmbed
